export default "__VITE_ASSET__DSTabmfM__"